export default {
    global: {
        /** Hex: #CD202C */
        red: '#CD202C',
        /** Hex: #BC1D28 */
        darkRed: '#BC1D28',
        /** Hex: #fff */
        white: '#fff',
        /** Hex: #f7f7f7 */
        background: '#f7f7f7',
    },
    ess: {
        /** Hex: #000 */
        primary: '#000',
        secondary: {
            /** Hex: #EDEDED */
            lightestGrey: '#EDEDED',
            /** Hex: #E2DFDF */
            lightGrey: '#E2DFDF',
            /** Hex: #939598 */
            midGrey: '#939598',
            /** Hex: #58595B */
            darkGrey: '#58595B',
            /** Hex: #373737 */
            darkestGrey: '#373737',
        },
    },
    mep: {
        /** Hex: #3D3C3E */
        primary: '#3D3C3E',
        secondary: {
            /** Hex: ##F4F4F4 */
            lightestGrey: '#F4F4F4',
            /** Hex: #EEEEEF */
            lightGrey: '#EEEEEF',
            /** Hex: #E6E6E6 */
            midGrey: '#E6E6E6',
            /** Hex: #8C8E91 */
            darkGrey: '#8C8E91',
            /** Hex: #58595B */
            darkestGrey: '#58595B',
        },
    },
};
